export type Proposal = {
  id: string;
  title: string;
  body: string;
  choices: string[];
  start: number;
  end: number;
  snapshot: string;
  state: string;
  author: string;
  authorEns?: string;
  created: number;
  plugins: any;
  network: string;
  type: string;
  ipfs: string;
  votes: number;
  scores: string[];
  strategies: Strategy[];
  space: Space;
};

export type Vote = {
  id: string;
  voter: string;
  created: number;
  choice: any;
};

export type Strategy = {
  name: string;
  params: {
    symbol: string;
    address: string;
    decimals: number;
  };
};

export type Space = {
  id: string;
  name: string;
  network: string;
  strategies: Strategy[];
  admins: string[];
  members: string[];
  avatar: string;
  symbol: string;
};

export enum VotingSystem {
  SINGLE_CHOICE = 'single-choice',
  APPROVAL = 'approval',
  QUADRATIC = 'quadratic',
  RANKED_CHOICE = 'ranked-choice',
  WEIGHTED = 'weighted'
}
